<template>
  <v-dialog
    v-model="showContactUsModal"
    max-width="500"
    @keydown.esc="dismiss"
  >
    <v-card>
      <v-card-title class="primary--text">Contact Us</v-card-title>
      <v-card-text>
        <v-textarea
          v-model="emailBody"
          label="Enter your message"
          outlined
          rows="5"
          class="mt-3"
        ></v-textarea>
        <div class="mt-3">
          By clicking submit, an email will be sent to
          <strong class="primary--text mb-1">{{ $i18n.t('fields.supportOnviv') }}</strong>.
          <v-icon v-if="!isProd" color="primary" class="mr-6">fa-brands fa-jedi-order</v-icon>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dismiss">Cancel</v-btn>
        <v-btn
          :loading="loading"
          :disabled="loading"
          text
          color="primary"
          @click="sendEmail"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import { SupportService } from "@/service";

export default Vue.extend({
  name: "ContactUsModal",
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      emailBody: "",
      loading: false
    };
  },
  computed: {
    showContactUsModal: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean) {
        this.$emit("input", val);
      }
    },
    isProd(): boolean {
      return this.$store.getters.currentEnvironment === "prod";
    }
  },
  methods: {
    async sendEmail() {
      if (!this.emailBody.trim()) {
        this.$alert("Please enter a message before submitting.");
        return;
      }

      const payload = {
        emailBody: this.emailBody.trim()
      };

      if (this.loading) return;

      this.loading = true;

      try {
        await SupportService.createSupportEmail({ requestBody: payload });
        this.$alert("Your message has been sent successfully.");
        this.showContactUsModal = false;
        this.emailBody = "";
      } catch (error) {
        console.error("Error sending email:", error);
        this.$alert("An error occurred while sending your message. Please try again later.");
      } finally {
        this.loading = false;
      }
    },
    dismiss() {
        this.$emit('dimiss-contact-us');
    }
  }
});
</script>

<style lang="scss" scoped>
</style>
